/* Consent-gated legacy Meta PageView and Klaviyo onsite runtime. */
(function () {
  'use strict';

  var configNode = document.getElementById('VerychiMarketingConsentConfig');
  if (!configNode) return;

  var config = {};
  try {
    config = JSON.parse(configNode.textContent || '{}');
  } catch (e) {}

  var STORAGE_KEY = 'verychi_cookie_consent';
  var klaviyoLoaded = false;
  var facebookPageViewLoaded = false;

  function getConsent() {
    if (window.VerychiCookieConsent) return window.VerychiCookieConsent;
    try {
      return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
    } catch (e) {
      return null;
    }
  }

  function loadFacebookPageView() {
    if (facebookPageViewLoaded) return;
    facebookPageViewLoaded = true;
    var pixel = new Image(1, 1);
    pixel.style.display = 'none';
    pixel.alt = '';
    pixel.src = 'https://www.facebook.com/tr?id=' + config.metaPageViewId + '&ev=PageView&noscript=1';
    document.body.appendChild(pixel);
  }

  function identifyKlaviyo() {
    if (!config.customer) return;
    if (!window.klaviyo || typeof window.klaviyo.identify !== 'function') return;
    window.klaviyo.identify({
      'email': config.customer.email,
      '$first_name': config.customer.firstName,
      '$last_name': config.customer.lastName
    });
  }

  function loadKlaviyo() {
    if (klaviyoLoaded) {
      identifyKlaviyo();
      return;
    }
    klaviyoLoaded = true;
    var script = document.createElement('script');
    script.async = true;
    script.type = 'text/javascript';
    script.src = config.klaviyoSrc;
    script.onload = identifyKlaviyo;
    document.head.appendChild(script);
  }

  function applyConsent() {
    var consent = getConsent();
    if (!consent || !consent.marketing) return;
    loadFacebookPageView();
    loadKlaviyo();
  }

  applyConsent();
  window.addEventListener('verychi:cookie-consent', applyConsent);
})();
